import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
export function SnackBarAlertComponent(param) {
    let { open, onClose, message, alertColor } = param;
    const toastIdRef = useRef(null);
    const lastToastRef = useRef(null);
    useEffect(()=>{
        if (open && message) {
            var _lastToastRef_current, _lastToastRef_current1;
            const isSameToast = toastIdRef.current !== null && ((_lastToastRef_current = lastToastRef.current) === null || _lastToastRef_current === void 0 ? void 0 : _lastToastRef_current.message) === message && ((_lastToastRef_current1 = lastToastRef.current) === null || _lastToastRef_current1 === void 0 ? void 0 : _lastToastRef_current1.alertColor) === alertColor;
            if (isSameToast) {
                return;
            }
            if (toastIdRef.current !== null) {
                toast.dismiss(toastIdRef.current);
                toastIdRef.current = null;
            }
            const showToast = ()=>{
                switch(alertColor){
                    case 'success':
                        toastIdRef.current = toast.success(message, {
                            duration: 6000
                        });
                        break;
                    case 'error':
                        toastIdRef.current = toast.error(message, {
                            duration: 6000
                        });
                        break;
                    case 'info':
                        toastIdRef.current = toast.info(message, {
                            duration: 6000
                        });
                        break;
                    case 'warning':
                        toastIdRef.current = toast.warning(message, {
                            duration: 6000
                        });
                        break;
                    default:
                        toastIdRef.current = toast.error(message, {
                            duration: 6000
                        });
                }
            };
            lastToastRef.current = {
                message,
                alertColor
            };
            showToast();
        } else if (!open && toastIdRef.current !== null) {
            toast.dismiss(toastIdRef.current);
            toastIdRef.current = null;
            lastToastRef.current = null;
            onClose();
        }
    }, [
        open,
        message,
        alertColor,
        onClose
    ]);
    // Return null since Sonner handles rendering
    return null;
}
